<template>
    <modal :value="open" @input="handleEscape()">
        <template v-slot:header>
            <app-nav-header :show-back="showBack"
                            :search="search"
                            @close="close()"
                            @back="back()"
                            @close-search="$emit('close-search')"
                            @open-search="$emit('open-search')"
            ></app-nav-header>
        </template>
        <transition :name="noAnimation ? 'animation-disabled' : 'fade'" mode="out-in">
            <app-search v-if="search"></app-search>
            <app-nav-list v-else
                          :current="current"
                          @navigate="navigate($event)"
            ></app-nav-list>
        </transition>
        <lang-select disableFocus class="d-md-none lang-select--mobile"></lang-select>
    </modal>
</template>

<script>
    import AppNavList from './NavList';
    import AppNavHeader from './NavHeader';

    export default {
        name: 'app-nav',
        components: {
            AppNavList,
            AppNavHeader
        },
        props: ['nav', 'current', 'open', 'display-back', 'hide-footer', 'no-animation', 'search'],
        data () {
            return {
                langs: ['ENG', 'DK'],
                selectedLang: 'ENG',
                prevOpen: false,
            };
        },
        computed: {
            showBack () {
                return !!(this.current.parent && this.displayBack);
            },
            shouldAnimate () {
                return !this.noAnimation;
            }
        },
        methods: {
            close () {
                this.$emit('close');
            },
            back () {
                this.$emit('next', this.current.parent);
            },
            navigate (element) {
                if (element.child) {
                    this.$emit('next', element.child);
                }
            },
            handleEscape () {
                if (this.showBack) {
                    this.back();
                } else {
                    this.close();
                }
            }
        }
    };
</script>
